<script setup>
  import ComponentTooltip from "@components/Tooltips/Tooltip.vue";

  defineOptions({
    name: "PagesDevTooltip",
  });
</script>

<template>
  <div>
    scoll
    <br />
    scoll
    <br />
    scoll
    <br />
    scoll
    <br />
    scoll
  </div>
  <div class="grid grid-cols-1 gap-56">
    <section class="flex justify-center">
      placement: default (top)
      <ComponentTooltip
        tooltip="Das hier ist ein langer Tooltip Text, der sich automatisch ausrichten sollte. Mal sehen."
      >
        <div class="bg-mcred">HOVER ME</div>
      </ComponentTooltip>
    </section>

    <section class="flex justify-center">
      placement: top-start
      <ComponentTooltip
        tooltip="Das hier ist ein langer Tooltip Text, der sich automatisch ausrichten sollte. Mal sehen."
        placement="top-start"
      >
        <div class="bg-mcred">HOVER ME</div>
      </ComponentTooltip>
    </section>

    <section>
      placement: default (top)
      <div class="relative w-32 overflow-hidden border-2 border-mcred p-4">
        <ComponentTooltip
          tooltip="Das hier ist ein langer Tooltip Text, der sich automatisch ausrichten sollte. Mal sehen."
        >
          <div class="bg-mcred">HOVER ME</div>
        </ComponentTooltip>
      </div>
    </section>

    <section>
      placement: default (top)
      <div class="flex justify-end">
        <div class="relative right-0 w-32 overflow-hidden border-2 border-mcred p-4">
          <ComponentTooltip
            tooltip="Das hier ist ein langer Tooltip Text, der sich automatisch ausrichten sollte. Mal sehen."
          >
            <div class="bg-mcred">HOVER ME</div>
          </ComponentTooltip>
        </div>
      </div>
    </section>

    <section>
      placement: right
      <div class="relative w-32 overflow-hidden border-2 border-mcred p-4">
        <ComponentTooltip placement="right">
          <template #tooltip>
            Das hier ist ein langer Tooltip Text, der sich automatisch ausrichten sollte. Mal sehen.
            <br />
            Hier auch
            <br />
            mit HTML
            <br />
            und Zeilenumbrüchen.
          </template>
          <div class="bg-mcred">HOVER ME</div>
        </ComponentTooltip>
      </div>
    </section>

    <section class="flex justify-end">
      placement: right
      <div class="relative w-32 overflow-hidden border-2 border-mcred p-4">
        <ComponentTooltip placement="right">
          <template #tooltip>
            Das hier ist ein langer Tooltip Text, der sich automatisch ausrichten sollte. Mal sehen.
            <br />
            Hier auch
            <br />
            mit HTML
            <br />
            und Zeilenumbrüchen.
          </template>
          <div class="bg-mcred">HOVER ME</div>
        </ComponentTooltip>
      </div>
    </section>

    <div>
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
      scoll
      <br />
    </div>
  </div>
</template>
